module.exports = __webpack_public_path__ + "img/mba-responsible.49a167e1.jpg";